export var formatDecimal = function (value, useThousandSeparator) {
    if (useThousandSeparator === void 0) { useThousandSeparator = false; }
    if (value === 0) {
        return '0.00';
    }
    if (value) {
        if (useThousandSeparator) {
            return value.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
        return value.toFixed(2);
    }
    return '';
};
export var formatCurrency = function (value) {
    if (value === 0) {
        return '0.0000';
    }
    if (value) {
        return value.toFixed(4);
    }
    return '';
};
